export default "__VITE_ASSET__BTerhZgr__"